var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuStatus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1112_1503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.3666 4.20039H7.63327C7.43087 4.20039 7.2666 4.03015 7.2666 3.82039V0.780391C7.2666 0.570631 7.43087 0.400391 7.63327 0.400391H8.3666C8.569 0.400391 8.73327 0.570631 8.73327 0.780391V3.82039C8.73327 4.03015 8.569 4.20039 8.3666 4.20039Z",
    fill: "#afb5d2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M8.3666 15.5998H7.63327C7.43087 15.5998 7.2666 15.4296 7.2666 15.2198V12.1798C7.2666 11.97 7.43087 11.7998 7.63327 11.7998H8.3666C8.569 11.7998 8.73327 11.97 8.73327 12.1798V15.2198C8.73327 15.4296 8.569 15.5998 8.3666 15.5998Z",
    fill: "#afb5d2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.7998 8.3666V7.63327C11.7998 7.43087 11.97 7.2666 12.1798 7.2666H15.2198C15.4296 7.2666 15.5998 7.43087 15.5998 7.63327V8.3666C15.5998 8.569 15.4296 8.73327 15.2198 8.73327H12.1798C11.97 8.73327 11.7998 8.569 11.7998 8.3666Z",
    fill: "#7e86a8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M0.399902 8.3666V7.63327C0.399902 7.43087 0.570142 7.2666 0.779902 7.2666H3.8199C4.02966 7.2666 4.1999 7.43087 4.1999 7.63327V8.3666C4.1999 8.569 4.02966 8.73327 3.8199 8.73327H0.779902C0.570142 8.73327 0.399902 8.569 0.399902 8.3666Z",
    fill: "#7e86a8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10.9734 5.55669L10.4434 5.02672C10.2969 4.88018 10.2969 4.64293 10.4434 4.49676L12.5637 2.37651C12.7102 2.22996 12.9474 2.22996 13.0936 2.37651L13.6236 2.90648C13.7701 3.05303 13.7701 3.29027 13.6236 3.43645L11.5033 5.55669C11.3572 5.70324 11.1199 5.70324 10.9734 5.55669Z",
    fill: "#7e86a8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M2.90648 13.6231L2.37651 13.0931C2.22996 12.9466 2.22996 12.7093 2.37651 12.5632L4.49676 10.4429C4.6433 10.2964 4.88055 10.2964 5.02672 10.4429L5.55669 10.9729C5.70324 11.1194 5.70324 11.3567 5.55669 11.5029L3.43645 13.6231C3.29027 13.7696 3.05265 13.7696 2.90648 13.6231Z",
    fill: "#afb5d2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M10.4434 10.9729L10.9734 10.4429C11.1199 10.2964 11.3572 10.2964 11.5033 10.4429L13.6236 12.5632C13.7701 12.7097 13.7701 12.947 13.6236 13.0931L13.0936 13.6231C12.9471 13.7696 12.7098 13.7696 12.5637 13.6231L10.4434 11.5029C10.2969 11.3567 10.2969 11.1194 10.4434 10.9729Z",
    fill: "#afb5d2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M2.37651 2.90648L2.90648 2.37651C3.05303 2.22996 3.29027 2.22996 3.43645 2.37651L5.55669 4.49676C5.70324 4.6433 5.70324 4.88055 5.55669 5.02672L5.02672 5.55669C4.88018 5.70324 4.64293 5.70324 4.49676 5.55669L2.37651 3.43645C2.22996 3.29027 2.22996 3.05265 2.37651 2.90648Z",
    fill: "#afb5d2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1112_1503"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#5D6588"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuStatus);
export default __webpack_public_path__ + "static/media/menu-status.3fc54c8c9e19d7a54c65185f68bd2a8e.svg";
export { ForwardRef as ReactComponent };